export type PageSample = {
  src: string
  level: string
  title: string
  caption: string
}

export const pageSamples: PageSample[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/odq3TNrmKZ8yWBuq85tkei/Captura-de-pantalla-2026-09-13-a-las-2.24.47_p._m..webp',
    level: 'Volume 1 · Attività Gioco',
    title: 'Pratica con i Tre Livelli',
    caption:
      'Scheda pronta da stampare: nove foto reali di movimento da identificare come alto, medio o basso, più un esercizio da disegnare per i 4-6 anni.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/te2pKYdZyxXeG4toCT6TRf/Captura-de-pantalla-2026-09-13-a-las-2.27.48_p._m..webp',
    level: 'Volume 2 · Guida Tecnica',
    title: 'Il Plié Perfetto — Piegamento di Base',
    caption:
      'Le quattro posizioni del plié spiegate passo dopo passo, con indicazioni di allineamento e un confronto SÌ / NO per correggere gli errori.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/usGpCoVLfCXFTwbNqMUxjt/Captura-de-pantalla-2026-09-13-a-las-2.28.59_p._m..webp',
    level: 'Volume 3 · Infografica di Movimento',
    title: 'Grand Allegro — Grandi Salti',
    caption:
      'Petit e grand allegro a confronto, con jeté, grand jeté e assemblé illustrati e spiegati per sapere quando usarli.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ui69LSP41EMYi95eYiTnZH/Captura_de_pantalla_2026-09-13_a_las_2.31.24_p.webp',
    level: 'Volume 5 · Struttura Coreografica',
    title: 'Coreografia Agonistica',
    caption:
      'Una struttura in cinque fasi con tempi precisi — apertura, crescita, picco, risoluzione, finale — più i criteri di giudizio.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wrqKyBKtQqv9RititTVncC/Captura_de_pantalla_2026-09-13_a_las_2.33.16_p.webp',
    level: 'Volume 6 · Unità Elite',
    title: 'Psicologia Agonistica e Mindset',
    caption:
      'Psicologia della performance, resilienza e protocolli di allenamento mentale usati dai campioni, per i livelli avanzati e professionali.',
  },
]
